import getWrappedUseMutation from "api/helpers/getWrappedUseMutation";
import apiClient from "api-client";

export const useCreateOfficeMutation = getWrappedUseMutation(apiClient.Offices.post);

export const useUpdateOfficeMutation = getWrappedUseMutation(apiClient.Offices.put);

export const useDeleteOfficeMutation = getWrappedUseMutation(apiClient.Offices.delete);
